import { render, staticRenderFns } from "./addVideo.vue?vue&type=template&id=73e6ab8f&scoped=true&"
import script from "./addVideo.vue?vue&type=script&lang=js&"
export * from "./addVideo.vue?vue&type=script&lang=js&"
import style0 from "./addVideo.vue?vue&type=style&index=0&id=73e6ab8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e6ab8f",
  null
  
)

export default component.exports